export default __webpack_public_path__ + "images/referenzen/animationsfilm/saxovent_animationsfilm.mp4";